import React, {useState, useRef} from "react";
import Spinner from "./Spinner";
import {ChevronDownIcon, ChevronUpIcon} from "@heroicons/react/24/outline";


const buttonStyles = {
  default: "text-white bg-black-500 border-black-500 hover:bg-am-700",
  empty: "text-am-700 bg-transparent hover:bg-white border-am-700",
  emptyWhite: "text-am-white bg-transparent hover:bg-white hover:bg-opacity-30 border-white",
  white: "text-am-700 bg-white hover:bg-ivory border-white",
  secondary: "text-am-700 bg-indigo-100 hover:bg-indigo-200",
  danger: "text-white bg-red-600 hover:bg-red-700",
  pink: "text-black bg-pink-200 hover:bg-pink-400",
  gray: "text-black bg-gray-300 hover:bg-gray-400",
  blue: "text-black bg-blue-100 hover:bg-blue-200",
  blueWhite: "text-blue-500 bg-white hover:bg-blue-200 border-blue-500 hover:border-blue-200 hover:text-black",
  greenBlack: "text-black bg-kkgreen-400 hover:bg-white hover:text-kkgreen-400 hover:border-kkgreen-400",
  green: "text-white bg-kkgreen-400 hover:bg-white hover:text-kkgreen-400 hover:border-kkgreen-400",
  darkGreen: "text-white bg-kerakoll-700 hover:bg-kkgreen-400",
  greenWhite: "text-kkgreen-400 bg-white hover:bg-kkgreen-400 border-kkgreen-400 hover:text-white",
  red: "text-white bg-red-500 hover:bg-red-700",
  redWhite: "text-red-600 bg-white hover:bg-red-600 border-red-600 hover:text-white",
  greyedOut: "text-gray-400 bg-gray",
  none: "",
};

const dropdownStyles = {
  default: "text-white bg-am-500 hover:bg-am-700 border-gray-500",
  white: "text-black bg-white hover:bg-gray-100 border-gray-100",
}

const Button = ({
  full = false,
  className = "",
  containerClassName = "",
  paddingCls = "",
  textCls = "text-base",
  fontCls = "font-semibold",
  borderCls = "border border-gray-300",
  children,
  styleType = "default",
  submitting = false,
  hideSpinner = false,
  disabled = false,
  subitems = null,
  subitemsDropdownCls = 'left-0',
  subitemsDropdownStyleType = 'default',
  subitemsDropdownCloseOnClick = false,
  subitemsDropdownBig = false,
  big = false,
  Icon = null,
  uppercase = true,
  ...rest
}) => {

  const [showSubitmes, setShowSubitmes] = useState(false);
  const subitemsRef = useRef(null);

  if (!paddingCls)
    paddingCls = big ? 'px-6 pb-3 pt-2' : 'px-4 pb-2 pt-1.5';

  let defaultClasses =
    `relative overflow-hidden ${uppercase ? "uppercase" : ""} justify-center inline-flex items-center ${paddingCls} ${borderCls} ${textCls} ${fontCls} focus:outline-none active:opacity-70 `;

  if (buttonStyles[styleType] !== undefined) {
    defaultClasses += buttonStyles[styleType];
  } else {
    defaultClasses += buttonStyles.default;
  }

  if (disabled)
    defaultClasses += " opacity-30";

  if (subitems?.length > 0)
    rest = {...rest, onClick: () => { setShowSubitmes(!showSubitmes); }}

  return <div className={`relative ${containerClassName} ${disabled ? "cursor-not-allowed" : ""}`}>
    <button
      disabled={submitting || disabled}
      className={`${defaultClasses} ${className} ${full ? "w-full" : ""} ${disabled ? "pointer-events-none" : ""}`}
      onBlur={(e) => {
        if (showSubitmes && subitemsRef.current?.contains(e.relatedTarget) === false)
          setShowSubitmes(false);
      }}
      {...rest}
    >
      <div className="flex items-center gap-1.5">
        {!!Icon && <Icon className={`w-4 h-4 ${React.Children.count(children) > 0 ? 'mr-1 mt-0.5' : ''}`} />}
        {children}
        {
          !Icon && subitems?.length > 0 && (
            !showSubitmes
              ? <ChevronDownIcon className="w-4 h-4" />
              : <ChevronUpIcon className="w-4 h-4" />
          )
        }
      </div>
      {submitting && !hideSpinner ? (
        <Spinner classes={buttonStyles[styleType]} styleType={styleType} />
      ) : null}
    </button>
    {
      <ol
        ref={subitemsRef}
        className={`${showSubitmes && subitems?.length > 0 ? 'block' : 'hidden'} ${subitemsDropdownCls} absolute z-50 mt-0.5 overflow-hidden shadow-md`}
        tabIndex="0"
      >
        {
          subitems?.map(({title, onClick}, idx) => (
            <li
              key={idx}
              className={[
                'whitespace-nowrap text-center',
                subitemsDropdownBig ? 'px-8 py-4' : 'px-3 py-2',
                dropdownStyles[subitemsDropdownStyleType],
                !!onClick ? 'cursor-pointer' : '',
                idx < subitems.length -1 && 'border-b'
              ].join(' ')}
              onClick={() => {
                if (!!onClick)
                  onClick();
                if (subitemsDropdownCloseOnClick)
                  setShowSubitmes(false);
              }}
            >
              {title}
            </li>
          ))
        }
      </ol>
    }
  </div>
};

export default Button;
